import type { LineChartOptions } from '@/types/options';

export const options: LineChartOptions = {
  margins: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  withAxes: false,
  showArea: true,
  startOnZero: true,
  withLegend: false,
  tooltipOptions: {
    showTitle: false,
  },
};
